import style from '../css/Report.module.css';

function Content({ pdfUrl }) {
    return (
        <div className={style.contentContainer}>
            <div className={style.viewer}>
                {pdfUrl && (
                    <iframe
                        id="pdf-preview"
                        src={pdfUrl}
                        title="PDF Preview"
                        style={{
                            flexGrow: 1,
                            border: 'none',
                            width: '100%',
                            height: '100%',
                        }}
                    ></iframe>
                )}
            </div>
        </div>
    )
}
export default Content;